import { FC } from "react"
import { useHeroVitalsContext } from "@/providers/HeroVitals/HeroVitals.context"
import { VitalBars } from "@/ui/VitalBars"

export const HeroVitalBars: FC = () => {
  const vitals = useHeroVitalsContext()

  if (vitals.length === 0) {
    return null
  }

  return <VitalBars vitals={vitals} />
}
